/**
 * @file
 * The header sort pills.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el, iconButton, onClick } = berTags.dom;
  const { announce } = berTags.util;

  // Header sort pills. Owns the active field/direction, re-picking a field
  // flips its direction. onChange receives the new sort.
  components.sortBar = ({ fields, value, onChange }) => {
    const bar = el('div', 'ber-tags__sort');
    let sort = value;

    const dirLabel = (dir) =>
      dir === 'desc' ? Drupal.t('descending') : Drupal.t('ascending');

    const sync = () => {
      bar.querySelectorAll('.ber-tags__sort-option').forEach((option) => {
        const active = !!sort && option.dataset.field === sort.field;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) {
          option.dataset.dir = sort.dir;
          option.setAttribute(
            'aria-label',
            `${option.dataset.label} (${dirLabel(sort.dir)})`,
          );
        } else {
          delete option.dataset.dir;
          option.setAttribute('aria-label', option.dataset.label);
        }
      });
    };

    fields.forEach(({ field, label, icon: iconName }) => {
      const option = iconButton('ber-tags__sort-option', label, iconName);
      option.dataset.field = field;
      option.dataset.label = label;
      onClick(option, (event) => {
        event.stopPropagation();
        sort =
          sort && sort.field === field
            ? { field, dir: sort.dir === 'asc' ? 'desc' : 'asc' }
            : { field, dir: 'asc' };
        sync();
        onChange(sort);
        announce(`${label}, ${dirLabel(sort.dir)}`);
      });
      bar.appendChild(option);
    });

    sync();
    return { el: bar, sync, current: () => sort };
  };
})(Drupal);
